// import { Button, Input, Spinner } from "@nextui-org/react";
// import * as React from "react";
// import { useSignin } from "./useSignin";
// import { Link } from "react-router-dom";
// import { Path } from "app/path";
// import { BrandInput } from "app/subframe/components/BrandInput";
// import { AsButton } from "app/subframe";
// import { Icon, twClassNames } from "@subframe/core";
// import AllSetSvg from "app/assets/images/allSet.svg";
// import Logo from "app/assets/images/logo.svg";
// import { LogoWithName } from "app/components/logoWithName";
//
// export interface SigninProps {}
//
// export const Signin: React.FC<SigninProps> = (props) => {
//   const { handleSigninSubmit, loading, showPassword, setShowPassword } =
//     useSignin();
//
//
//
//   return (
//
//     <form
//       onSubmit={handleSigninSubmit}
//       className="container max-w-none flex h-[100dvh] w-full flex-col items-center justify-center gap-4 bg-millet-500 py-12 mobile:px-4 mobile:py-12"
//     >
//       <div className="flex flex-col items-center justify-center gap-10 mobile:h-auto mobile:w-full mobile:flex-none">
//         <LogoWithName shouldScale={false} />
//         <div className="flex w-112 flex-col items-center gap-1 mobile:h-auto mobile:w-full mobile:flex-none">
//           <BrandInput
//             className="h-14 w-full flex-none"
//             placeholder="Your email"
//             textPosition="left"
//             name="email"
//             defaultValue={
//               process.env.REACT_APP_ENV === "development"
//                 ? "codyc@heyallset.com"
//                 : ""
//             }
//             type="email"
//             required
//           />
//           <BrandInput
//             className="h-14 w-full flex-none"
//             placeholder="Password"
//             textPosition="left"
//             type={showPassword ? "text" : "password"}
//             trailingComponent={
//               <Icon
//                 className={twClassNames(
//                   "text-body font-body text-neutral-500 inline-flex px-4"
//                 )}
//                 onClick={() => setShowPassword(!showPassword)}
//                 name={showPassword ? "FeatherEye" : "FeatherEyeOff"}
//               />
//             }
//             name="password"
//             defaultValue={
//               process.env.REACT_APP_ENV === "development" ? "password123" : ""
//             }
//             required
//           />
//         </div>
//         <AsButton
//           className="h-14 w-full flex-none"
//           variant="brand"
//           leadingIcon={null}
//           trailingIcon={null}
//           text="Log in"
//           size="lg"
//           loader={loading}
//           type="submit"
//         />
//         <AsButton
//           variant="link"
//           leadingIcon={null}
//           trailingIcon={null}
//           text="Forgot password?"
//           size="xs"
//           loader={false}
//           disabled={false}
//           shadow={false}
//         />
//       </div>
//     </form>
//   );
// };


import * as React from "react";
import { useState } from "react";
import { BrandInput } from "app/subframe/components/BrandInput";
import { AsButton } from "app/subframe";
import { Icon, twClassNames } from "@subframe/core";
import { LogoWithName } from "app/components/logoWithName";
import { useSignin } from "./useSignin";

type LoginType = "admin" | "employee";
export interface SigninProps {
  defaultTab?: "admin" | "employee";
}


export const Signin: React.FC<SigninProps> = ({ defaultTab = "admin" }) => {
  const [activeTab, setActiveTab] = useState<LoginType>(defaultTab);

  const {
    handleSigninSubmit,
    loading,
    showPassword,
    setShowPassword,
  } = useSignin();

  return (
      <form
          onSubmit={(e) => handleSigninSubmit(e, activeTab)}
          className="container max-w-none flex h-[100dvh] w-full flex-col items-center justify-center gap-4 bg-millet-500 py-12 mobile:px-4"
      >
        <div className="flex flex-col items-center justify-center gap-10 mobile:w-full">
          <LogoWithName shouldScale={false} />

          {/* Tabs */}
          <div className="flex w-112 gap-2 mobile:w-full">
            <button
                type="button"
                onClick={() => setActiveTab("admin")}
                className={twClassNames(
                    "flex-1 rounded-md py-3 text-sm font-medium",
                    activeTab === "admin"
                        ? "bg-white text-black"
                        : "bg-gray-300 text-white/70 border border-white/30"
                )}
            >
              Admin Login
            </button>

            <button
                type="button"
                onClick={() => setActiveTab("employee")}
                className={twClassNames(
                    "flex-1 rounded-md py-3 text-sm font-medium",
                    activeTab === "employee"
                        ? "bg-white text-black"
                        : "bg-gray-300 text-white/70 border border-white/30"
                )}
            >
              Employee Login
            </button>
          </div>

          {/* Inputs */}
          <div className="flex w-112 flex-col gap-1 mobile:w-full">


            <BrandInput
                textPosition="left"
                className="h-14 w-full"
                placeholder="Your email"
                name="email"
                type="email"
                required
            />

            <BrandInput
                textPosition="left"
                className="h-14 w-full"
                placeholder="Password"
                type={showPassword ? "text" : "password"}
                name="password"
                required
                trailingComponent={
                  <Icon
                      className="inline-flex px-4 text-neutral-500"
                      onClick={() => setShowPassword(!showPassword)}
                      name={showPassword ? "FeatherEye" : "FeatherEyeOff"}
                  />
                }
            />

            {activeTab === "employee" && (
                <BrandInput
                    textPosition="left"
                    className="h-14 w-full"
                    placeholder="Employee Code"
                    name="employeeCode"
                    type="text"
                    required
                />
            )}
          </div>

          {/* Submit */}
          <AsButton
              className="h-14 w-112 mobile:w-full"
              variant="brand"
              text={activeTab === "admin" ? "Log in as Admin" : "Log in as Employee"}
              size="lg"
              loader={loading}
              type="submit"
          />
        </div>
      </form>
  );
};
